export default "__VITE_PUBLIC_ASSET__fcc167f8__"